import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol, ContenedorBoton } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelTotales, LabelValorTotales } from '../componentes_generales/componentes_formulario/labels/';
import global_axios  from '../../funciones_globales/interaccionapi';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { validarFechaMomentEnFormatoString, validarCampoString, esNumero, validarJSON } from '../../funciones_globales/utils';
import { formatearFechaMoment_a_String, formatearNumeroDecimal } from '../../funciones_globales/format';
import { validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils';
import { addItemArray, deleteItemArray } from '../../funciones_globales/arrays';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cargarCatalogosGenericoAsync, generarItemCatalogoSeleccionado, cargarCatalogoEstados, cargarCatalogosGenericoAsyncInvertido } from '../../funciones_globales/catalogos';
import { cargar_CuentasBancarias } from '../../actions/bancos/act_banc01';
import { cargar_CuentaContable } from '../../actions/contabilidad/act_con02';

class FormBanco12 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            operacion: 'G',            
            fechaDeposito: null,
            catalogoCtasBancarias: [],
            cuentaDep_sel: null,
            movimientoId: '',
            comprobanteId: '',
            referencia: '',
            fechaVenc: null,
            cliente_sel: null,
            valEfectivo: '',
            valOtros: '',
            valorItemCtaCtble: '',
            concepto: '',
            estadosMovBanco: [],
            estadoActual: 'P',
            detalleMvtoCtble: [],
            cuentaCtble_sel: null,            
            deshabilitarSelectCuentaDep: false,
            totalDebe: 0,
            totalHaber: 0,
            totalDeposito: 0,
            movCaja: '',

            columDefGridCuentas:[
                {   header: "No.",
                    field: "Nro",
                    width: 30,
                    type: "string"
                },
                {   header: "Cuenta",
                    field: "Cuenta",
                    width: 120,
                    type: "string"
                },                                   
                {   header: "Descripción",
                    field: "Descripcion",
                    width: 240,
                    type: "string"
                },
                {   header: "Concepto",
                    field: "Concepto",
                    width: 300,
                    type: "string",
                    editable: true
                },
                {   header: "D/H",
                    field: "DebeHaber",
                    width: 40,
                    type: "string"                                                         
                },                                                               
                {   header: "Debe",
                    field: "Debe",
                    width: 70,
                    type: "num_decimal_edit",
                    editable: true
                },
                {   header: "Haber",
                    field: "Haber",
                    width: 70,
                    type: "num_decimal_edit",
                    editable: true
                },
                {   header: "",
                    field: "eliminar",
                    width: 50,
                    type: "link_elim"
                }                            
            ]
        }
        
        this.gridCuentasOptions = {
            context: {
                componentParent: this
            },            
            suppressRowClickSelection: true,
            singleClickEdit: true,
            enableColResize: true,
            enableCellChangeFlash: true,
            onCellValueChanged:(event=>{
                switch (event.colDef.field){
                    case 'Concepto':
                        event.data.Concepto =  event.data.Concepto.toString().toUpperCase();
                        break;
                    case 'Debe':
                    case 'Haber':
                        this.calcularTotalDebeHaber();
                        break;
                    default:
                        break;
                }
                this.apiCuentas.refreshCells();
            }),
            onRowDataChanged: (()=>{
                /* Cada vez que el grid de detalle sufra un cambio se recalcularán los totales*/
                this.calcularTotalDebeHaber();
            }),
            onCellEditingStarted: ((event)=>{
                if (event.column.colId==='Debe'){
                    if(event.data.DebeHaber==='H' || event.data.Autogenerada){
                        this.apiCuentas.stopEditing(true);
                        return;
                    }
                }

                if (event.column.colId==='Haber'){
                    if(event.data.DebeHaber==='D' || event.data.Autogenerada){
                        this.apiCuentas.stopEditing(true);
                        return;
                    }
                }
              }),
        }
        
        this.handleInputChange = this.handleInputChange.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.getDepositobyId = this.getDepositobyId.bind(this);
        this.guardarDeposito = this.guardarDeposito.bind(this);
        this.anularDeposito = this.anularDeposito.bind(this);
        this.handleAddCuentaContable = this.handleAddCuentaContable.bind(this);
        this.getOptions_CtasContables = this.getOptions_CtasContables.bind(this);
        this.handleChangeCuentaBancaria = this.handleChangeCuentaBancaria.bind(this);
        this.onGridCuentasReady = this.onGridCuentasReady.bind(this);
        this.calcularTotalDeposito = this.calcularTotalDeposito.bind(this);
        this.calcularTotalDebeHaber = this.calcularTotalDebeHaber.bind(this);
    }

    onGridCuentasReady(params){
        this.apiCuentas = params.api;
        this.columnApiCuentas = params.columnApi;
    }
  
    componentDidMount(){
        Promise.all([
            cargarCatalogoEstados('MovBanco', 'Status'),
            this.props.cargar_CuentasBancarias(),
            this.props.generar_LogAuditoriaIngresoForm('0712')
        ])
        .then(([estadosMovBco])=>{
            try {
                let cuentasBancarias = this.props.cuentasBancarias;
                let catalogoCtasBancarias = [];
                cuentasBancarias.forEach(item => {
                    catalogoCtasBancarias.push({value: item.Cuenta, label: `${item.Nombre.toString().trim().toUpperCase()} (${item.Numero.toString().trim()})`});
                });

                let fechaProceso = getFechaProcesoPorModulo('07');
                
                this.setState({ fechaDeposito: moment(fechaProceso, 'DD/MM/YYYY'), catalogoCtasBancarias,
                                estadosMovBanco: estadosMovBco, cuentasBancarias
                });
            } catch (error) {
                alert(`Ocurrió un error al cargar los datos de inicialización. Error: ${error}`);
            }
        })
        .catch(error => {
            alert(error.response?error.response.data.msg:error.message);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0712');
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 3 ){
          let query = "?tipo=catalogo&cadena_busq=" + input;     
          cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_CtasContables(input, callback){
        /* cuentas?cadena_busq=52.02.20.12&dep=001 filtro de cuentas por departamento */
        if (input.toString().length >= 2 ){
            let cadena_busq = `?cadena_busq=${input}&dep=${this.props.departamento}`;
            cargarCatalogosGenericoAsyncInvertido('/cuentas', cadena_busq, callback)
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type==='checkbox'?target.checked:target.value;
        const name = target.name;
        this.setState({ [name]: value });
    }

    handleAddCuentaContable(){
        if(this.state.cuentaCtble_sel===null){
            alert('No ha especificado una Cuenta Contable.');
            return;
        }

        if(!validarCampoString(this.state.concepto, 1, 80)){
            alert('No ha especificado correctamente el Concepto.');
            return;
        }

        if(!validarCampoString(this.state.valorItemCtaCtble, 1, 10)){
            alert('Debe especificar el valor del item de desglose contable a añadir.');
            return;
        }

        if(validarCampoString(this.state.valorItemCtaCtble, 1, 10)){
            if(!esNumero(this.state.valorItemCtaCtble)){
                alert('No ha especificado correctamente el Valor de la cuenta que va a añadir.');
                return;
            }else{
                if(parseFloat(this.state.valorItemCtaCtble)<=0){
                    alert('No ha especificado correctamente el Valor de la cuenta que va a añadir.');
                    return;
                }
            }
        }        

        this.addItemDetalleMvtoCtble({  Cuenta: this.state.cuentaCtble_sel.value,
                                        Descripcion: this.state.cuentaCtble_sel.label,
                                        Concepto: this.state.concepto.trim().toUpperCase(),
                                        DebeHaber: 'H',
                                        Debe: '',
                                        Haber: this.state.valorItemCtaCtble,
                                        Autogenerada: false
                                    });
    }

    obtenerCodCuentaCtbleDeCuentaBancaria(codCuentaBco){
        let codCtaCtble = null;
        for (let i=0; i<this.props.cuentasBancarias.length; i++){
            let ctaBanco = this.props.cuentasBancarias[i];
            
            if(ctaBanco.Cuenta.trim().toUpperCase()===codCuentaBco.trim().toUpperCase()){
                codCtaCtble = ctaBanco.ConCuenta;
                break;
            }
        }
        return codCtaCtble;
    }

    handleChangeCuentaBancaria(value){
        try {            
            let cuentaBancaria_sel = (value===null)?null:value.value;
            let descripCuentaBancaria_sel = (value===null)?null:value.label;
            

            if(cuentaBancaria_sel!==null){
                let ctaContable = this.obtenerCodCuentaCtbleDeCuentaBancaria(cuentaBancaria_sel);

                if(validarCampoString(ctaContable, 2, 17)){
                    this.props.cargar_CuentaContable(getItemDatosSesion('planVigente'), ctaContable)
                    .then(()=>{
                        if(validarJSON(this.props.cuentaContable)){
                            this.addItemDetalleMvtoCtble({  Cuenta: this.props.cuentaContable.Cuenta,
                                                            Descripcion: this.props.cuentaContable.Nombre===null?'':this.props.cuentaContable.Nombre.trim().toUpperCase(),
                                                            Concepto: `DEPOSITO ${descripCuentaBancaria_sel}`,
                                                            DebeHaber: 'D',
                                                            Debe: this.state.totalDeposito===0?'':this.state.totalDeposito,
                                                            Autogenerada: true,
                                                        });
                            this.setState({deshabilitarSelectCuentaDep: true});
                        }
                    })
                }else{
                    alert('La cuenta bancaria para depositar que seleccionó no tiene una cuenta contable relacionada.');
                }               
            }

            this.setState({ cuentaDep_sel: cuentaBancaria_sel});
        } catch (error) {
            alert(`Ocurrió un error al verificar los datos de la cuenta bancaria seleccionada. Error: ${error}`);
        }
    }

    calcularTotalDeposito(){
        let totalDeposito = 0;
        if(esNumero(this.state.valEfectivo)){
            totalDeposito += parseFloat(this.state.valEfectivo);
        }
        
        if(esNumero(this.state.valOtros)){
            totalDeposito += parseFloat(this.state.valOtros);
        }

        this.setState({totalDeposito});
    }

    calcularTotalDebeHaber(){
        let totalDebe = 0;
        let totalHaber = 0;

        this.state.detalleMvtoCtble.forEach(item => {
            if(item.DebeHaber==='D'){
                if(esNumero(item.Debe)){
                    totalDebe = parseFloat(totalDebe) + parseFloat(item.Debe);
                }
            }else{
                if(item.DebeHaber==='H'){
                    if(esNumero(item.Haber)){
                        totalHaber = parseFloat(totalHaber) + parseFloat(item.Haber);
                    }
                }
            }
        });      

        this.setState({totalDebe, totalHaber});
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('07');

        this.setState({
            operacion: 'G',
            movimientoId: '',
            comprobanteId: '',
            referencia: '',
            fechaDeposito: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaVenc: null,
            cliente_sel: null,
            cuentaDep_sel: null,
            valEfectivo: '',
            valOtros: '',
            valorItemCtaCtble: '',
            concepto: '',
            estadoActual: 'P',
            detalleMvtoCtble: [],
            cuentaCtble_sel: null,            
            deshabilitarSelectCuentaDep: false,
            totalDebe: 0,
            totalHaber: 0,
            totalDeposito: 0,
            movCaja: ''
        });
    }

    addItemDetalleMvtoCtble(itemMvtoCtble){
        this.setState({detalleMvtoCtble: addItemArray(this.state.detalleMvtoCtble, itemMvtoCtble)});
    }

    methodFromParent(id, datosFilaElim) {
        if(datosFilaElim.Autogenerada){
            alert('No puede eliminar una fila autogenerada.');
            return;
        }

        let eliminar = window.confirm(`¿Está seguro de eliminar la fila seleccionada?`);
        if (eliminar){
            this.setState({detalleMvtoCtble: deleteItemArray(this.state.detalleMvtoCtble, id)} );
        }
    }
    
    getDepositobyId(){

        let movimientoId = this.state.movimientoId;
        if (!validarCampoString(movimientoId, 6)){
            alert('No ha especificado un No. de Movimiento válido.');
            return;
        }

        this.props.cambiar_VisualizacionLoading(true);

        global_axios({
            method: 'GET',
            url: '/depositos/' + movimientoId,
        })
        .then((response)=> {
            let deposito = response.data;
            
            this.setState({
                operacion: 'M',
                movimientoId: deposito.Movimiento,
                comprobanteId: deposito.Comprobante,
                referencia: deposito.Referencia,
                fechaDeposito: (deposito.Fecha!==null?moment(deposito.Fecha, 'DD/MM/YYYY'):null),
                fechaVenc: (deposito.Vencimiento!==null?moment(deposito.Vencimiento, 'DD/MM/YYYY'):null),
                cliente_sel:  ((deposito.cli===null || deposito.cli===undefined)?null:generarItemCatalogoSeleccionado(deposito.cli.Codigo, deposito.cli.Nombre)),
                cuentaDep_sel: deposito.Cuenta,
                valEfectivo: parseFloat(deposito.Valor!==null?deposito.Valor:0).toFixed(2),
                valOtros: parseFloat(deposito.Otros!==null?deposito.Otros:0).toFixed(2),
                concepto: deposito.Concepto,
                estadoActual: deposito.Status,
                movCaja: deposito.MovCaja===null?'':deposito.MovCaja,
                detalleMvtoCtble: deposito.detMovBanco.map(item=>{ return { Nro: item.Secuencia,
                                                                            Cuenta: item.ctaCtble.Cuenta,
                                                                            Descripcion: item.ctaCtble.Nombre.trim().toUpperCase(),
                                                                            Concepto: item.Concepto,
                                                                            DebeHaber: item.DebeHaber,
                                                                            Debe: item.DebeHaber==='D'?item.Valor:'',
                                                                            Haber: item.DebeHaber==='H'?item.Valor:''
                                                                        }
                                                                })                
            });
            
            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch((error)=>{
            this.props.cambiar_VisualizacionLoading(false);
            if (error.response.status === 404){
                alert(`El No. de Movimiento: ${movimientoId} (tipo: Depósito) no existe o está anulado.`);
            }else{
                alert(error.response?error.response.data.msg:error.message);
            }
        });
    }

    guardarDeposito(){
        try {
            let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
            if (!validPermiso.esValido){
                alert(validPermiso.msg);
                return;
            }

            let fechaProceso = getFechaProcesoPorModulo('07');

            let fechaDeposito = formatearFechaMoment_a_String(this.state.fechaDeposito);
            if (!validarFechaMomentEnFormatoString(fechaDeposito)){
                alert('La Fecha de Depósito es inválida.');
                return;
            }

            if (this.props.permiteCambioFProceso==='S'){
                let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaDeposito, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
                
                if(!validFProceso.esValida){
                    alert(validFProceso.msg);
                    return;
                }
            }

            let valorEfectivo = 0;
            let valorCheques = 0;

            if(validarCampoString(this.state.valEfectivo, 1, 10)){                
                if(esNumero(this.state.valEfectivo)){
                    valorEfectivo = parseFloat(this.state.valEfectivo).toFixed(2);
                }else{
                    alert('No ha especificado correctamente el campo Val. Efectivo.');
                    return;
                }
            }

            if(validarCampoString(this.state.valOtros, 1, 10)){
                if(esNumero(this.state.valOtros)){
                    valorCheques = parseFloat(this.state.valOtros).toFixed(2);
                }else{
                    alert('No ha especificado correctamente el campo Val. Cheque.');
                    return;
                }
            }
            
            if(parseFloat(valorEfectivo)===0 && parseFloat(valorCheques)===0){
                alert('No ha especificado Val. Efectivo ni tampoco Val. Cheque.');
                return;
            }

            if(!validarCampoString(this.state.cuentaDep_sel, 2)){
                alert('No ha especificado la Cuenta en la que va a depositar.');
                return;
            }

            if(!validarCampoString(this.state.referencia, 1, 12)){
                alert('No ha especificado correctamente el campo Referencia.');
                return;
            }

            if(!validarCampoString(this.state.concepto, 1, 80)){
                alert('No ha especificado correctamente el campo Concepto.');
                return;
            }

            if(this.state.detalleMvtoCtble.length===0){
                alert('No ha especificado el desglose contable del Depósito.')
                return;
            }

            if(this.state.totalDebe !== this.state.totalHaber){
                alert('En el desglose contable el Total Debe es diferente al Total Haber.');
                return;
            }

            let datosDeposito = {
                referencia: this.state.referencia,
                concepto: this.state.concepto,
                fechaDeposito,
                valorEfectivo,
                valorCheques,
                fechaVcto: fechaDeposito,
                cuenta: this.state.cuentaDep_sel,
                moneda: JSON.parse(getItemDatosSesion('moneda')).Moneda,
                dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
                usuario: getItemDatosSesion('usuario'),
                planVigente: getItemDatosSesion('planVigente'),
                detalleMovBancoDeposito: this.state.detalleMvtoCtble.map(item=> { return {  ctaContable: item.Cuenta,
                                                                                            debeHaber: item.DebeHaber,
                                                                                            valor: parseFloat(item.DebeHaber==='D'?item.Debe:item.Haber),
                                                                                            concepto: item.Concepto                                                                                        
                                                                                        }
                                                                                })
            };
            
            this.props.cambiar_VisualizacionLoading(true);
            
            global_axios({
                method: 'POST',
                url: '/depositos',            
                data: datosDeposito
            })
            .then(()=> {
                this.props.cambiar_VisualizacionLoading(false);
                alert(`El depósito se registró correctamente.`);
                this.limpiar();
            })
            .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(error.response?error.response.data.msg:error.message);
            });            
        } catch (error) {
            alert(`Ocurrió un error al intentar guardar el Depósito. Error: ${error}`);
        }
    }

    anularDeposito(){
        
        let movimientoId = this.state.movimientoId;
        let estadoMov = this.state.estadoActual;

        if (this.state.operacion!=='M'){
            alert('No ha seleccionado un Movimiento Banco (tipo Depósito) para anular.');
            return;
        }

        if (!validarCampoString(movimientoId, 6)){
            alert('No ha especificado un No. de Movimiento Banco (tipo Depósito) válido.');
            return;
        }

        let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
        if (!validPermiso.esValido){
            alert(validPermiso.msg);
            return;
        }

        if (estadoMov!=='P'){
            alert('El estado actual del Movimiento Banco (tipo Depósito) no permite que se anule.');
            return;
        }

        let continuarAnul = window.confirm(`¿Está seguro de anular el Movimiento Banco (tipo Depósito) No.: ${movimientoId} ?`);    
        if (!continuarAnul){
            return;
        }

        this.props.cambiar_VisualizacionLoading(true);
        
        global_axios({
            method: 'DELETE',
            url: '/depositos/' + movimientoId,
            headers: {'idregaudit': this.props.idRegAudit}
        })
        .then(()=> {
            this.props.cambiar_VisualizacionLoading(false);
            alert(`El No. de Movimiento (tipo Depósito): ${movimientoId} fue anulado correctamente.`);
            this.limpiar();
        })
        .catch((error)=>{
            this.props.cambiar_VisualizacionLoading(false);
            alert(error.response?error.response.data.msg:error.message);
        });
    }

    render(){

        return(
            <ContenedorForm porc_ancho={70}>
                <HeaderForm>
                    <TituloForm>Depósitos</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={10}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Movimiento:</LabelForm>
                            <InputSearch tipoInput='text' nombre='movimientoId' placeholder='Movimiento' valor={this.state.movimientoId}
                                func_CambiarValor={this.handleInputChange} func_BuscarValor={this.getDepositobyId}
                                func_OnFocus={()=>{this.limpiar()}}/>
                        </ContainerCol>                        
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha Dep.:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaDeposito} disabled={!(this.props.permiteCambioFProceso==='S')}
                                func_onChange={(fecha)=>{this.setState({fechaDeposito: fecha})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Val. Efectivo:</LabelForm>
                            <InputText type='text' autoComplete='off' name='valEfectivo' value={this.state.valEfectivo} className='form-control input-sm'
                                maxLength={10} placeholder='0.00' onChange={this.handleInputChange} onBlur={this.calcularTotalDeposito}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Val. Cheque:</LabelForm>
                            <InputText type='text' autoComplete='off' name='valOtros' value={this.state.valOtros} className='form-control input-sm' 
                                maxLength={10} placeholder='0.00' onChange={this.handleInputChange} onBlur={this.calcularTotalDeposito}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Cuenta:</LabelForm>
                            <ReactSelect options={ this.state.catalogoCtasBancarias } value={this.state.cuentaDep_sel}
                                func_onChange={(value)=>{if(Array.isArray(value)){value=null;} this.handleChangeCuentaBancaria(value);}}
                                disabled={this.state.deshabilitarSelectCuentaDep}/>
                        </ContainerCol>                        
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Referencia:</LabelForm>
                            <InputText type='text' autoComplete='off' name='referencia' value={this.state.referencia} className='form-control input-sm' 
                                placeholder='Referencia' onChange={this.handleInputChange} maxLength={12}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-8'>
                            <LabelForm>Concepto:</LabelForm>
                            <InputText type='text' autoComplete='off' name='concepto' value={this.state.concepto} className='form-control input-sm'
                                placeholder='Concepto' onChange={this.handleInputChange} maxLength={80}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>No. Depósito:</LabelForm>
                            <InputText type='text' name='comprobanteId' value={this.state.comprobanteId} className='form-control input-sm' 
                                readOnly={true} placeholder='No. Depósito' onChange={this.handleInputChange}/>
                        </ContainerCol>
                    </Row>
                    <Row>                        
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Cliente:</LabelForm>
                            <ReactSelectAsync value={this.state.cliente_sel} func_loadOptions={this.getOptions_Clientes} 
                                func_onChange={(value)=>{this.setState({cliente_sel: value })}} disabled={true}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Fecha Cobro:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaVenc} disabled={true}
                                func_onChange={(fecha)=>{this.setState({fechaVenc: fecha})}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Mov. Caja:</LabelForm>
                            <InputText type='text' name='movCaja' value={this.state.movCaja} className='form-control input-sm' 
                                readOnly={true} placeholder='M. Caja' onChange={this.handleInputChange}/>
                        </ContainerCol>                        
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Estado:</LabelForm>
                            <ReactSelect options={ this.state.estadosMovBanco } disabled={true} value={this.state.estadoActual}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <hr/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-5'>
                            <LabelForm>Cuenta Contable:</LabelForm>
                            <ReactSelectAsync value={this.state.cuentaCtble_sel} func_loadOptions={this.getOptions_CtasContables}
                                func_onChange={(value)=>{this.setState({cuentaCtble_sel: value!==null?value:null})}}/> 
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Valor:</LabelForm>
                            <InputText type='text' autoComplete='off' name='valorItemCtaCtble' value={this.state.valorItemCtaCtble} className='form-control input-sm' 
                                maxLength={10} placeholder='0.00' onChange={this.handleInputChange}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-1'>
                            <ContenedorBoton margen_arriba={15}>
                                <Tooltip placement='right' overlay='Añadir una cuenta contable'>
                                    <div className='btn-group pull-left'>
                                        <button type='button' className='btn btn-success btn-sm' onClick={this.handleAddCuentaContable}><i className='fa fa-plus'></i></button>
                                    </div>
                                </Tooltip>
                            </ContenedorBoton>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <AgGridRender altura='170px' data={this.state.detalleMvtoCtble} columnas={this.state.columDefGridCuentas} gridOptions={this.gridCuentasOptions}
                            onGridReady={this.onGridCuentasReady}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-offset-4 col-sm-4'>
                            <span className='pull-right'>
                                <LabelTotales>Total Debe:</LabelTotales>
                                <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDebe)}</LabelValorTotales>
                            </span>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4'>
                            <span className='pull-right'>
                                <LabelTotales>Total Haber:</LabelTotales>
                                <LabelValorTotales>{formatearNumeroDecimal(this.state.totalHaber)}</LabelValorTotales>
                            </span>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12' margen_arriba={25}>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' onClick={this.guardarDeposito}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                                <button type='button' className='btn btn-danger btn-sm' onClick={this.anularDeposito}><i className='fa fa-minus-circle fa-lg'/> Anular</button>
                                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {    permiso: state.sesion.valoresSesionForm.Permiso,
                idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,                
                permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
                diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
                departamento : state.sesion.valoresSesionForm.Departamento,
                cuentasBancarias: state.bancos.cuentasBancarias,
                cuentaContable: state.contabilidad.cuentaContable
        }
});
  
const mapDispatchToProps = ((dispatch) => {
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                            cambiar_VisualizacionLoading, cargar_CuentasBancarias, cargar_CuentaContable }, dispatch)
});
  
export default connect(mapStateToProps, mapDispatchToProps)(FormBanco12);